import { Field, Command, Params, Headers } from "./types";
import { FIELD_TYPES } from "../constants/fieldTypes";
import { object, string, mixed, ValidationError } from "yup";

export const addFieldValidation = (shape: any, field: Field) => {
  // if (field.type === FIELD_TYPES.INTEGER) {
  //   let check = number().integer().label(field.name).typeError('you must specify a number')
  //   if (!!field.min) check = check.min(field.min)
  //   if (!!field.max) check = check.max(field.max)
  //
  //   shape[field.name] = check
  // }

  // Key for params is field name(Field.name).  For headers it is the header
  // name(Field.header).
  const shapeKey = field.header ? field.header : field.name;

  // integers are validated the same as strings, so min = 5 means minimum 5 characters
  if (field.type === FIELD_TYPES.INTEGER && field.type === FIELD_TYPES.TEXT) {
    let check = string().label(field.name);
    if (!!field.min) check = check.min(field.min);
    if (!!field.max) check = check.max(field.max);
    if (field.regex) check = check.matches(new RegExp(field.regex));

    shape[shapeKey] = check;
  }

  if (field.type === FIELD_TYPES.LIST) {
    const check = mixed().label(field.name).oneOf(field.list!);

    shape[shapeKey] = check;
  }

  if (field.required) {
    const check = shape[shapeKey] || mixed().label(field.name);

    if (field.requiredWhenNoOtherFields) {
      shape[shapeKey] = check.test(
        "required",
        `${[field.name, field.requiredWhenNoOtherFields].reverse().join(" or ")} is required`,
        function (this: any, value: any) {
          const { parent } = this;

          if (
            field.requiredWhenNoOtherFields!.some(
              (name: string) =>
                parent[name] !== null && parent[name] !== undefined,
            )
          )
            return true;

          return value !== null && value !== undefined;
        },
      );
    } else {
      shape[shapeKey] = check.required();
    }
  }
};

export const createValidationSchema = (chain: Command[]) => {
  const shape: any = {};

  chain.forEach((command) => {
    if (!command.fields) return;

    command.fields.forEach((field) => addFieldValidation(shape, field));
  });

  return object().shape(shape);
};

export const validateParams = (
  chain: Command[],
  params: Params,
  headers: Headers,
) => {
  // For now, just check params and headers together.
  createValidationSchema(chain).validateSync({ ...params, ...headers });

  const allowedParamNames = chain
    .map((command) => (command.fields || []).map(({ name }) => name))
    .flat();

  for (const name in params) {
    if (!allowedParamNames.includes(name))
      throw new ValidationError(`parameter not found`, name, name);
  }
};
